var React = require('react');

function AlertInline (props) {
    return React.createElement("g",props,[React.createElement("rect",{"id":"Rectangle","fill":"#262626","rx":"4","key":0}),React.createElement("path",{"d":"M33.608,36.604 L34.796,19 L29,19 L30.152,36.604 L33.608,36.604 Z M34.58,44.632 L34.58,39.304 L29.216,39.304 L29.216,44.632 L34.58,44.632 Z","id":"!","fill":"#F5F2F0","fillRule":"nonzero","key":1})]);
}

AlertInline.defaultProps = {"id":"Icons/64/hinweis/dark","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"};

module.exports = AlertInline;

AlertInline.default = AlertInline;
